angular.module('SpidApp')

.factory('MoneyTransfer', [function () {
    var MoneyTransfer = function (params) {
        params = params || {}
        
        this.id          = params.id
        this.from        = params.from
        this.to          = params.to
        this.amount      = params.amount
        this.destination = params.destination
        this.current	 = params.current
        this.agencyId    = params.agency_id
        this.userId      = params.user_id
        this.updated_at  = params.updated_at
    }
    
    MoneyTransfer.sources = {
          DRAWER : 'DRAWER'
        , SAFE   : 'SAFE'
        , OUT    : 'OUT'
    }
    
    MoneyTransfer.prototype.isFromOut = function(){
    	return (this.to === MoneyTransfer.sources.SAFE && this.from === MoneyTransfer.sources.OUT);
    }
    
    MoneyTransfer.prototype.isToOut = function(){
    	return (this.to === MoneyTransfer.sources.OUT && this.from === MoneyTransfer.sources.SAFE);
    }
    
    MoneyTransfer.prototype.isToDrawer = function(){
    	return (this.to === MoneyTransfer.sources.DRAWER);
    }
    
    MoneyTransfer.prototype.isFromDrawer = function(){
    	return (this.from === MoneyTransfer.sources.DRAWER);
    }
    
    MoneyTransfer.prototype.getFormattedDate = function(){
    	return new Date(this.updated_at).toLocaleString();
    }

    return MoneyTransfer
}])